import { type Answer, isAvailableUnits, isReportsAnswerValue, isUnitsAnswerValue } from './types.no-deps'
import { pipe } from '../../lib/functional/pipe.no-deps'
import { compact, filter, filterOut, flatten, map, mapField, uniq } from '../../lib/functional/array.no-deps'
import type * as Flow from '../flows/types.no-deps'
import * as Reports from '../reports/types.no-deps'

export function getUnitsInAnswers(answers: Answer[], reportDetails: Reports.ReportDetailMap) {
    const answerValues = answers.map((answer) => answer.value)
    const unitAnswers = pipe(
        answerValues,
        filter(isUnitsAnswerValue),
        mapField('value'),
        filter(isAvailableUnits),
        flatten
    )
    const reportAnswers = pipe(
        answerValues,
        filter(isReportsAnswerValue),
        mapField('value'),
        flatten,
        map((report) => reportDetails[report]?.unitSubjectId),
        filterOut((x) => x == null)
    )
    return uniq(unitAnswers.concat(reportAnswers))
}

// Helper function to extract raw answers from the report answer's rawAnswer field
export const extractRawAnswers = (reportAnswers: Reports.Answer[]): Flow.Answer[] => {
    // Map over exhaustive answers to extract the raw answers
    return pipe(reportAnswers, mapField('value'), filter(Reports.hasRawAnswer), mapField('rawAnswer'), compact)
}

export function getSubReportIds(answers: Answer[]): Flow.ReportIds {
    return answers
        .filter((answer) => answer.value.type === 'reports')
        .flatMap((answer) => answer.value.value as Flow.ReportIds)
}
